import { render, staticRenderFns } from "./vuetiform-chipgroup.vue?vue&type=template&id=5af23331&scoped=true&"
import script from "./vuetiform-chipgroup.vue?vue&type=script&lang=js&"
export * from "./vuetiform-chipgroup.vue?vue&type=script&lang=js&"
import style0 from "./vuetiform-chipgroup.vue?vue&type=style&index=0&id=5af23331&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../@vue-modules/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af23331",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../@vue-modules/vuetify/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
installComponents(component, {VChip,VChipGroup})
